import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CandidateService } from 'src/app/_services/candidate.service';

@Component({
    selector: 'app-document-preview',
    templateUrl: './document-preview.component.html',
    styleUrls: ['./document-preview.component.scss'],
    standalone: false
})
export class DocumentPreviewComponent implements OnInit {
  candidateid: any
  cvdetails: any
  candidatedocid: any
  previewresumeurl: any
  constructor(private candidateservice: CandidateService, private router: Router, private sanitization: DomSanitizer) { }

  ngOnInit() {
    this.candidateid = this.router.url.split('/')[2]
    this.candidatedocid = this.router.url.split('/')[3]
    this.getCandidatedocuments()
  }

  getCandidatedocuments() {
    this.candidateservice.fetchcvdetails(this.candidateid).subscribe((res: any) => {
      if (res.status == 'success') {
        this.cvdetails = res.cvdetails
        if (this.cvdetails && this.cvdetails.length > 0) {
          const previewurl = this.cvdetails.filter(x=>x.candidatedocid == this.candidatedocid)[0].previewurl
          this.previewdoc(previewurl)
        }
      }
      // if(this.tabtoShow == 'files') {
      //   if (this.fileslider) {
      //     let el: HTMLElement = this.fileslider.nativeElement;
      //     el.click();
      //   }
      // }
    })
  }

  previewdoc(data) {
    this.previewresumeurl = null
      this.candidateservice.resumeurl(data).subscribe((res: any) => {
        var file3 = new Blob([res], { type: 'application/pdf' });
        this.previewresumeurl = this.sanitization.bypassSecurityTrustResourceUrl(URL.createObjectURL(file3) + "#toolbar=0&navpanes=0&scrollbar=0")
      })
    }
  }

